import {
  TextField,
  Button,
  FormControl,
} from '@material-ui/core';
import AudioPreviewer from '../Document/AudioPreviewer';
import { DocumentTypeObject } from '../../types/AppTypes';
import { useEffect, useState } from 'react';

const ReplacementForm = ({
  replacement,
  updateReplacementRow,
  deleteReplacementRow,
  updatePattern,
  updateReplacement,
  updateCategory,
  updateOrder,
  updateSample,
  updateComments,
  permissions,
  userInfo
}): JSX.Element => {

  const[jargon, setJargon] = useState('');

  const document = new DocumentTypeObject();

  document.speechParams.languageCode = 'en-US';
  document.speechParams.voiceId = 'Joanna';
  document.speechParams.engine = 'neural';
  document.speechParams.domain = '';
  document.speechParams.sampleRate = 24000;
  document.speechParams.prosodyRate = 110;

  const removePlaceholders=()=>{
    const regex = /\$\d+/g;
    const inputString = replacement.replacement
    const stringWithoutPlaceholders = inputString.replace(regex, "");
    setJargon(stringWithoutPlaceholders);
  }

  useEffect(() => {
    removePlaceholders()
  }, [replacement.replacement])
  
  return (
    <>
      <FormControl fullWidth variant="standard">
        <TextField
          id="standard-basic"
          label="Pattern"
          variant="standard"
          value={replacement.pattern}
          onChange={updatePattern}
        />
      </FormControl>
      <FormControl fullWidth variant="standard">
        <TextField
          id="standard-basic"
          label="Replacement"
          variant="standard"
          value={replacement.replacement}
          onChange={updateReplacement}
        />
      </FormControl>
      {replacement.category==='acronym' &&
        <AudioPreviewer text={jargon} document={document} autoplay={false} id="audio-player-1" />
      }
      <FormControl fullWidth variant="standard">
        <TextField
          id="standard-basic"
          label="Category"
          variant="standard"
          value={replacement.category}
          onChange={updateCategory}
        />
      </FormControl>
      <FormControl fullWidth variant="standard">
        <TextField
          id="standard-basic"
          type='number'
          label="Order"
          variant="standard"
          value={replacement.order}
          onChange={updateOrder}
        />
      </FormControl>
      {/*<FormControl fullWidth variant="standard">
        <TextField
          id="standard-basic"
          label="Sample"
          variant="standard"
          value={replacement.sample}
          onChange={updateSample}
        />
      </FormControl>
      <FormControl fullWidth variant="standard">
        <TextField
          id="standard-basic"
          label="Comments"
          variant="standard"
          value={replacement.comments}
          onChange={updateComments}
        />
  </FormControl>*/}
      <div className="stack">
        <Button
          className="button"
          variant="contained"
          onClick={() => updateReplacementRow({  })}
        >
          Update
        </Button>
        {(permissions?.includes('replacements.delete') || userInfo?.isAdmin) && ( 
          <Button
            className="button"
            variant="contained"
            onClick={() => deleteReplacementRow({  })}
          >
            Delete
          </Button>)
        }
      </div>
    </>
  );
};

export default ReplacementForm;